/** @format */

import TooltipButton from '@atoms/TooltipButton';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import styled from 'styled-components';

interface TooltippedLabelProps {
  label: React.ReactNode;
  tooltip: React.ReactNode;
}

const StyledTooltipLabel = styled.span`
  display: flex;
  gap: 6px;
  z-index: 9;
  align-items: center;
`;

const StyledTooltipIcon = styled.span`
  position: relative;
  display: flex;
  align-items: center;
`;

function TooltippedLabel(props: TooltippedLabelProps) {
  return (
    <StyledTooltipLabel>
      <span>{props.label}</span>
      <TooltipButton tooltip={props.tooltip}>
        <FontAwesomeIcon icon={['fas', 'question-circle']} style={{ height: '12px', cursor: 'pointer' }} />
      </TooltipButton>
    </StyledTooltipLabel>
  );
}

export default TooltippedLabel;
